import { render, staticRenderFns } from "./LogoInput2.vue?vue&type=template&id=54c71677&"
import script from "./LogoInput2.vue?vue&type=script&lang=js&"
export * from "./LogoInput2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/agent_ai/agent-ai-builder/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c71677')) {
      api.createRecord('54c71677', component.options)
    } else {
      api.reload('54c71677', component.options)
    }
    module.hot.accept("./LogoInput2.vue?vue&type=template&id=54c71677&", function () {
      api.rerender('54c71677', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/LogoInput2.vue"
export default component.exports